"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module("common").controller("SelectUserController", function ($scope, UsersService, positions, ModalService) {
  var _this = this;

  $scope.refresh = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(user) {
      var values;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("refresh in SelectUserController : ", positions);

              _context.next = 3;
              return UsersService.remoteSelectArray(positions);

            case 3:
              values = _context.sent;


              if (values) {
                $scope.to.options = values;
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  $scope.create = function () {
    console.log();
    ModalService.open("users/user", { position: positions[0] }).then(function (user) {
      $scope.refresh(user);
    });
  };

  $scope.reset = function () {
    console.log("reset");

    $scope.model[$scope.options.key] = null;
    $scope.optionName = "";
    $scope.$applyAsync();

    if ($scope.options.templateOptions.refresh) {
      $scope.options.templateOptions.refresh();
    }
  };

  $scope.edit = function () {
    console.log("edit", $scope.model[$scope.options.key]);

    ModalService.open("users/user", {
      _id: $scope.model[$scope.options.key].substring(1)
    }).then(function (user) {
      console.log("close open user =", user);
      $scope.refresh(user);
    });
  };
});